import { getCookieValue } from 'utils/cookie';
import Logger from '../logger/logger';
import ERRORS from '../errors/errorids';
import AppError from '../errors/apperror';
const log = Logger.get('refersion');

const rfsn_expires_cookie = getCookieValue('rfsn_expires');
const rfsn_expires_localstorage = localStorage.getItem('rfsn_expires');

export const manageRefersionField = (key, value) => {
	if (localStorage.getItem(key)) {
		// check expiry date if field already exists in local storage
		if (rfsn_expires_localstorage < new Date().getTime()) {
			localStorage.removeItem(key);
			localStorage.removeItem('rfsn_expires');
		}
	} else if (value) {
		// add field/value to local storage and expiry date
		try {
			localStorage.setItem(key, value);
			localStorage.setItem('rfsn_expires', rfsn_expires_cookie);
		} catch (err) {
			log.send(new AppError({
				message: 'manageRefersionField() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: err,
				visualisers: { feature: 'REFERSION' }
			}));
		}
	}
};

export const saveRefersionFieldsToStorage = () => {
	['rfsn_aid', 'rfsn_ci', 'rfsn_cs'].forEach(field => manageRefersionField(field, getCookieValue(field)));
};


// WEBPACK FOOTER //
// ./src/utils/refersion.js